<template>
  <div class="newsCase">
    <el-row :gutter="10" type="flex" class="row-bg" justify="center">
      <el-col :span="24">
        <!-- <div class="searchCase">

          <input type="text" placeholder="请输入关键词" v-model="formData.key">
          <span @click="searchBtn">检索</span>
        </div> -->
          <div class="aa">
            <mt-datetime-picker
              ref="picker"
              type="date"
              year-format="{value} 年"
              month-format="{value} 月"
              date-format="{value} 日"
              @confirm="handleConfirm"
              v-model="dateval">
            </mt-datetime-picker>
            <mt-datetime-picker
              ref="picker1"
              type="date"
              year-format="{value} 年"
              month-format="{value} 月"
              date-format="{value} 日"
              @confirm="handleConfirms"
              v-model="dateval">
            </mt-datetime-picker>
          </div>
        <el-row style="margin-bottom:0;background:#fff;padding:0 10px 0 14px;" :gutter="16">
          <el-col :lg='5' :md='8' :sm='24' :xs='24'>
            <div class="block">
              <div class="title">
                车型
              </div>
              <div>
                <el-input v-model="formData.vehicleType" placeholder="请填写车型"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24'>
            <div class="block">
              <div class="title">
                预警类型
              </div>
              <div>
                <el-input v-model="formData.alarmType" placeholder="请填写预警类型"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24'>
            <div class="block">
              <div class="title">
                案件名称
              </div>
              <div>
                <el-input v-model="formData.title" placeholder="请填写案件名称"></el-input>
              </div>
            </div>
          </el-col>
          <el-col  :lg='9' :md='24' :sm='24' :xs='24'>
            <div class="block">
              <div class="title">
                时间区间
              </div>
              <div>
                <el-date-picker placeholder="开始日期" type="date" :clearable="true" value-format="yyyy-MM-dd" v-model="formData.startDate"></el-date-picker>
              </div>
              <div>
                <el-date-picker placeholder="结束日期" type="date" :clearable="true" value-format="yyyy-MM-dd" v-model="formData.endDate"></el-date-picker>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="searchCase1">

          <!-- <input type="text" placeholder="请输入关键词" v-model="formData.key"> -->
          <span @click="searchBtn">检索</span>
        </div>
       <!-- <div class="warning" style="padding-top:0" v-if="user.type == 1">
          <div
            @click="formData.easy = !formData.easy;warningClick()"
            :class="formData.easy? 'warningSelection' : ''"
          >
            <b></b>易
          </div>
          <div
            @click="formData.hard = !formData.hard;warningClick()"
            :class="formData.hard? 'warningSelection' : ''"
          >
            <b></b>难
          </div>
          <div
            @click="formData.lt2h = !formData.lt2h;warningClick()"
            :class="formData.lt2h ? 'warningSelection' : ''"
          >
            <b></b>非预警
          </div>
          <div
            @click="formData.all = !formData.all;warningClick()"
            :class="formData.all? 'warningSelection' : ''"
          >
            <b></b>全部
          </div>
        </div> -->
        <!-- <div class="newsCaseList" style="text-align: center" v-if="!newsCaseListData.length">暂无案件</div> -->
          <div class="newsCaseList" v-for="item in newsCaseListData" :key="item.id">
          <ul>
            <li>
              <span>案件名称：</span>
              <span>{{item.title}}</span>
            </li>
            <li>
              <span>案件编号：</span>
              <span>{{item.caseNo}}</span>
            </li>
            <li>
              <span>车&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;型：</span>
              <span>{{item.vehicleType}}</span>
            </li>
            <li>
              <span>发生时间：</span>
              <span class="clOrange">{{item.incomTime}}</span>
            </li>
            <li>
              <span>初次对应时间：</span>
              <span>{{item.firstDate}}</span>
            </li>
            <li>
              <span>案件经过时间：</span>
              <span>{{item.elapsed}}</span>
            </li>
            <li>
              <span>预警类型：</span>
              <span>{{item.alarmType}}</span>
            </li>
            <li>
              <span>状态：</span>
              <span>{{item.status}}</span>
            </li>
            <div style="margin-top:10px;">
              <el-button  @click="jump(item.id)" style="background:#00ae66;color:#fff;margin-right:10px;" size="small">查看详情</el-button>
              <!-- <el-badge :value="item.unreadCount?item.unreadCount:''">
                <el-button size="small" style="background:#00ae66;color:#fff;" @click="chat(item.id)">消息</el-button>
              </el-badge> -->
            </div>
          </ul>
        </div>
        <infinite-loading @infinite="onInfinite" ref="infiniteLoading">
          <span slot="no-more">没有更多消息了</span>
        </infinite-loading>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getNiceCaseData, searchHandlingCaseData } from '@/api/case'
import { Indicator } from 'mint-ui'
import InfiniteLoading from 'vue-infinite-loading'
import {
  getOptions,
  getArealist,
  getLeader
} from '@/api/export.js'
export default {
  components: {
    InfiniteLoading
  },
  data () {
    // 由于是组件，data必须是个函数，这是ES6写法，data后面加括号相当于data: function () {}
    return {
      // 记得return不然接收不到数据
      newsCaseListData: [],
      searchKey: '', // 搜索关键词KEY
      warning: [], // 0黄色预警，1红色预警
      list: [],
      loading: true,
      isLoading: false,
      partIdsArr: [],
      phenomenonIdsArr: [],
      warrantyPeriod: [],
      kubunOption: [],
      warrantyPeriodOption: [],
      directionOption: [],
      leaderArr: [],
      areaOption: [],
      noMore: false,
      pageNumber: 0,
      pageSize: 10,
      cases: [],
      formData: {
        gt24h: false,
        gt8h: false,
        gt6h: false,
        gt2h: false,
        lt2h: false,
        all: false,
        back: false,
        easy: false,
        hard: false,
        key: '',
        pageSize: 10,
        pageNumber: 0,
        startDate: '',
        endDate: '',
        casePriority: '',
        fieldId: '',
        alarmType: ''
      },
      user: {},
      dateval: ''
    }
  },
  created () {
    this.user = JSON.parse(localStorage.getItem('user'))
    getOptions(0).then(res => {
      this.directionOption = res.data.directionOption
      this.kubunOption = res.data.kubunOption
      this.partIdsArr = res.data.partOption
      this.phenomenonIdsArr = res.data.phenomenonOption
      this.warrantyPeriodOption = res.data.warrantyPeriodOption
    })
    getLeader().then(res => {
      this.leaderArr = res.data.data
    })
    getArealist().then(res => {
      this.areaOption = res.data.data
    })
  },
  methods: {
    getNow (d) {
      const year = d.getFullYear()
      const month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      const date = d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate()
      const hours = d.getHours()
      const minutes = d.getMinutes()
      const second = d.getSeconds()
      let resStr = year + '-' + month + '-' + date
      return resStr
    },
    handleConfirm () {
      console.log(this.getNow(this.dateval))
      this.$set(this.formData, 'startDate', this.getNow(this.dateval))
    },
    handleConfirms () {
      console.log(this.getNow(this.dateval))
      this.$set(this.formData, 'endDate', this.getNow(this.dateval))
    },
    openPicker1 () {
      if (this.formData.endDate) {
        this.dateval = this.formData.endDate
      } else {
        this.dateval = new Date()
      }
      this.$refs.picker1.open()
    },
    openPicker () {
      if (this.formData.startDate) {
        this.dateval = this.formData.startDate
      } else {
        this.dateval = new Date()
      }
      this.$refs.picker.open()
    },
    chat (e) {
      var status = 1
      this.$router.push({ path: '/newsChat/' + status + '/' + e })
    },
    onInfinite ($state) {
      // Indicator.open({
      //   text: '加载中...',
      //   spinnerType: 'fading-circle'
      // });
      getNiceCaseData(this.pageNumber, this.pageSize, { ...this.formData }).then((res) => {
        this.totalPages = res.data.totalPages
        if (res.data.content.length) {
          this.pageNumber += 1
          this.newsCaseListData.push(...res.data.content)
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
        } else {
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
        }
        if (res.data.content.length < this.pageSize) {
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
        }
      })
    },
    searchBtn () {
      // Indicator.open({
      //   text: '加载中...',
      //   spinnerType: 'fading-circle'
      // });
      console.log(this.$route.params.status)
      let data = { key: this.searchKey }
      if (this.$route.params.status == 0) {
        // searchDraftCaseData(this.formData).then((res) => {
        //   this.newsCaseListData = res.data.content
        //   Indicator.close();
        // })
        this.formData.pageNumber = 0
        this.pageNumber = 0
        this.pageSize = 20
        this.newsCaseListData = []
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
        this.onInfinite()
      } else if (this.$route.params.status == 1) {
        this.formData.pageNumber = 0
        this.pageNumber = 0
        this.pageSize = 20
        this.newsCaseListData = []
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
        this.onInfinite()
        // searchUntreatedCaseData(this.formData).then((res) => {
        //   this.newsCaseListData = res.data.content
        //   Indicator.close();
        // })
      } else if (this.$route.params.status == 2) {
        searchHandlingCaseData(data).then((res) => {
          this.newsCaseListData = res.data.content
          Indicator.close()
        })
      }else {
        // searchClosingCaseData(this.formData).then((res) => {
        //   this.newsCaseListData = res.data.content
        //   Indicator.close();

        // })
        this.formData.pageNumber = 0
        this.pageNumber = 0
        this.pageSize = 20
        this.newsCaseListData = []
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
        this.onInfinite()
      }
    },
    jump (id) {
      // if(this.$route.params.status == 33){
      //   this.$router.push({ path: '/alarmInfo/' + id })
      // } else
      // if (this.$route.query.status == '0') {
      //   this.$router.push({ path: '/alarmAddedCase/' + id })
      // } else if (this.$route.query.status == '13') {
      //   this.$router.push({ path: '/alarmInfo/' + this.$route.query.status + '/' + id })
      // } else {
      //   this.$router.push({ path: '/alarmInfo/' + this.$route.query.status + '/' + id })
      // }
      this.$router.push({ path: '/niceCaseInfo/' +  id })
    },
    warningClick (e) {
      // 预警选择事件
      console.log(this.cases.length)
      if (e && e.length > 0) {
        if (this.cases.length == 0 || this.cases.join(',').indexOf(e) < 0) {
          this.cases.push(e)
        } else if (this.cases.join(',').indexOf(e) >= 0) {
          this.cases.splice(this.cases.indexOf(e), 1)
        }
        this.formData.casePriority = this.cases.join(',')
      }
      this.formData.pageNumber = 0
      this.pageNumber = 0
      let _this = this
      setTimeout(function () {
        _this.searchBtn()
      }, 0)
    }

  }
}
</script>

<style>
body,
html {
  margin: 0;
  padding: 0;
  background-color: #f4f4f4;
  height:100%;
}
.block {
		line-height: 40px;
		display: flex;
		/* justify-content: space-around; */
	}
.block .title {
		min-width: 85px;
		/* text-align: center; */
	}
ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
}
ul {
  margin: 0;
}
ul li {
  list-style-type: none;
}
.newsCase{
  overflow-x: hidden;
		margin-left: 10px;
		margin-right: 10px;
  height:100%;
}
.warning {
  width: calc(100% - 10px);
  background-color: #fff;
  overflow: hidden;
  padding: 7px 10px 7px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baselin;
  flex-shrink: 10;
}
.warning div {
  flex-grow: 4;
  padding: 7px 0;
  border: 1px solid #e3e3e3;
  color: #666;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  margin-left: 10px;
}

.warning div b {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px solid #e3e3e3;
  position: relative;
  left: -1px;
  top: 2px;
  border-radius: 3px;
}
.warningSelection {
  color: #4da2fd !important;
  border-color: #4da2fd !important;
  background-color: #ebf5ff !important;
}
.warningSelection b {
  background-image: url(../assets/images/warningSelection.png);
  border: 0 !important;
  background-size: 15px;
  background-position: center center;
}
.searchCase {
  text-align: center;
  height: 40px;
  overflow: hidden;
  background-color: #fff;
  padding: 10px 10px 3px 14px;
  position: relative;
}
.newsCase .searchCase1 {
  text-align: center;
  height: 40px;
  overflow: hidden;
  background-color: #fff;
  padding: 10px 10px 3px 14px;
  position: relative;
}
.searchCase input {
  width: calc(100% - 93px);
  height: 34px;
  border: 1px solid #e3e3e3;
  text-indent: 1em;
  border-radius: 3px 0 0 3px;
}
.searchCase span {
  display: block;
  width: 88px;
  float: right;
  font-size: 14px;
  color: #fff;
  height: 36px;
  line-height: 36px;
  background-color: #00ae66;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  top: 0;
  border-radius: 0 3px 3px 0;
  cursor: pointer;
}
.searchCase1 span {
  display: block;
  width: 88px;
  float: right;
  font-size: 14px;
  color: #fff;
  height: 36px;
  line-height: 36px;
  background-color: #00ae66;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  top: 10px;
  border-radius: 0 3px 3px 0;
  cursor: pointer;
}
.searchCase span:hover {
  cursor: pointer;
}
.searchCase {
  text-align: left;
  height: 40px;
  overflow: hidden;
  background-color: #fff;
  padding: 10px 15px 3px 15px;
}
.searchCase input {
  width: calc(100% - 120px);
  height: 32px;
  border: 1px solid #e3e3e3;
  text-indent: 1em;
}
.searchCase span {
  display: block;
  width: 88px;
  float: right;
  font-size: 14px;
  color: #fff;
  height: 36px;
  line-height: 36px;
  background-color: #00ae66;
  text-align: center;
  position: relative;
  left: -1px;
}
.searchCase span:hover {
  cursor: pointer;
}
.newsCaseList {
  background-color: #fff;
  text-align: left;
  margin-top: 10px;
  padding: 10px 15px;
}
.newsCaseList ul li {
  overflow: hidden;
  margin-top: 5px;
}
.newsCaseList ul li:hover {
  cursor: pointer;
}
.clOrange {
  color: #ff8f00 !important;
}
.newsCaseList ul li span {
  display: block;
  float: left;
  font-size: 14px;
  color: #333;
}
.infinite-status-prompt {
  margin-top: 10px;
  margin-bottom: 15px;
  height: 60px;
  color: #999;
  font-size: 12px;
}
</style>
